import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function sendReportAPI(report) {
  const url = `${AWS_API_URL}/report`;
  return postRequest(url, mapDataForBackend(report), await authorize());
}
